import styled from 'styled-components';
import {ENABLE_HOVER_ANIMATION, GAME_BOX} from '../../../css-constants';

export const GameInfoContainerDefaultBox = styled.div<{hasTwoLinesTitle: boolean}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 2px;
  width: 100%;
  transition: all 0.3s ease-in-out;
  padding-bottom: ${props => props.hasTwoLinesTitle? '0.6rem' : '0'};

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding-top: 0;
  }
  

  .${GAME_BOX}:hover &{
    &.${ENABLE_HOVER_ANIMATION} {
        transform: translateY(6rem);
        opacity: 0;
    }
    
`;
